import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = ({ artworkData }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState({ show: false, text: "", type: "ok" });

  useEffect(() => {
    if (artworkData) {
      setMessage(
        `Hello, I'm interested in the painting ${artworkData[0]}, ${artworkData[1]}, that is in the price of ${artworkData[2]}`
      );
    }
  }, [artworkData]);

  useEffect(() => {
    if (!toast.show) return;
    const t = setTimeout(() => setToast(s => ({ ...s, show: false })), 3000);
    return () => clearTimeout(t);
  }, [toast.show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);

    try {
      await emailjs.send(
        "service_a0mt5m7",
        "template_uy4k46l",
        { from_name: name, from_email: email, to_name: "Web Wizard", message },
        "7BCwN_wLUr1i9gl4E"
      );
      setName(""); setEmail(""); setMessage("");
      setToast({ show: true, text: "Thank you! Maria will contact you soon.", type: "ok" });
    } catch (err) {
      setToast({ show: true, text: `Error sending email: ${err?.text || err?.message || err}`, type: "error" });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      {toast.show && (
        <div className={`contact-toast ${toast.type === "error" ? "contact-toast--error" : "contact-toast--ok"}`}>
          {toast.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="emailForm container-fluid px-0">
        <div className="row justify-content-center">
          <div className="col-12 col-sm-11 col-md-9 col-lg-8">
            {/* Name */}
            <label htmlFor="cf-name" className="form-label d-none">Name</label>
            <input
              id="cf-name"
              type="text"
              className="form-control form-control-lg mb-3"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
            />

            {/* Email */}
            <label htmlFor="cf-email" className="form-label d-none">Email</label>
            <input
              id="cf-email"
              type="email"
              className="form-control form-control-lg mb-3"
              placeholder="youremail@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              inputMode="email"
            />

            {/* Message */}
            <label htmlFor="cf-message" className="form-label d-none">Message</label>
            <textarea
              id="cf-message"
              className="form-control form-control-lg mb-3"
              rows={4}
              placeholder="Your message here…"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />

            {/* Submit */}
              <button
                type="submit"
                className=" submitButton w-100 w-sm-auto px-4 py-3"
                disabled={sending}
              >
                {sending ? "Sending…" : "Send Email"}
              </button>
            </div>
          </div>
      </form>
    </>
  );
};

export default ContactForm;
